export const USER_AUTHED = "USER_AUTHED";
export const USER_LOGOUT = "USER_LOGOUT";